import React, { useEffect, useState } from "react";

const WeakConnectionWarning = () => {
  const [weakConnection, setWeakConnection] = useState(false);

  useEffect(() => {
    const checkConnection = () => {
      const connection =
        navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;

      if (connection) {
        const slowTypes = ["slow-2g", "2g", "3g"];
        setWeakConnection(slowTypes.includes(connection.effectiveType));

        // Re-check when connection changes
        connection.addEventListener("change", checkConnection);
      }
    };

    checkConnection();

    return () => {
      const connection =
        navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;

      if (connection) {
        connection.removeEventListener("change", checkConnection);
      }
    };
  }, []);

  return (
    <>
      {weakConnection && (
        <div
          style={{
            background: "#ffcc00",
            color: "#000",
            padding: "10px",
            textAlign: "center",
            fontWeight: "bold",
            zIndex: 9999,
          }}
        >
          ⚠️ Your internet connection seems weak.
        </div>
      )}
    </>
  );
};

export default WeakConnectionWarning;
